import { TicketPercent } from "lucide-react";
import { BlockCategory, registerBlock } from "../../lib/register-block";
import { ReturnDiscountCodeEditorRenderer } from "./editor";
import { ReturnDiscountCodeEmailRenderer } from "./email";
import type { ReturnDiscountCodeBlockProps } from "./types";

export default registerBlock<ReturnDiscountCodeBlockProps>({
  type: "return-discount-code",
  name: "editorBlocksLibrary.blocks.return-discount-code.title",
  description: "editorBlocksLibrary.blocks.return-discount-code.description",
  Icon: TicketPercent,
  category: BlockCategory.RETURN,
  hasDynamicContent: true,
  components: {
    email: {
      component: ReturnDiscountCodeEmailRenderer,
      editor: {
        component: ReturnDiscountCodeEditorRenderer,
      },
      configPanel: {
        features: {
          delete: true,
        },
      },
      compatibility: {
        rowBlock: false,
      },
    },
  },
});

export type { ReturnDiscountCodeBlockProps } from "./types";
